import { render, staticRenderFns } from "./agentBankInfo.vue?vue&type=template&id=384b0cc6&scoped=true&lang=html&"
import script from "./agentBankInfo.vue?vue&type=script&lang=js&"
export * from "./agentBankInfo.vue?vue&type=script&lang=js&"
import style0 from "./agentBankInfo.vue?vue&type=style&index=0&id=384b0cc6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384b0cc6",
  null
  
)

export default component.exports